import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=198f24cc&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('198f24cc')) {
      api.createRecord('198f24cc', component.options)
    } else {
      api.reload('198f24cc', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=198f24cc&", function () {
      api.rerender('198f24cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2F8Ue4Qyy7Wvo/JS/videoIframe.vue"
export default component.exports